import { EventListItem } from '@/types';

import { eventFormSchema } from './event-form.model';

export function isEventComplete(event: EventListItem): boolean {
  return eventFormSchema.isValidSync({
    status: 'PUBLISHED',
    label: event.label,
    eventTypeId: event.eventType.id,
    eventDate: new Date(event.eventDate),
    description: event.description ?? undefined,
    clientName: event.clientName ?? undefined,
    serviceName: event.serviceName ?? undefined,
    kpiIds: event.kpiIds,
  });
}
